import React, { useState, useEffect } from "react";
import "./HomeCms.scss";
import axios from "axios";
import { useDispatch } from "react-redux";
import { sidebarReducer } from "../../Redux/store";
import SearchBarComponent from "../../components/searchBar/searchBarComponent";
import { ReactComponent as AnalyticsSVG } from "../../images/new_ui/analytics.svg";
import { ReactComponent as Sessionlogo } from "../../images/new_ui/Sessionlogo.svg";
import { ReactComponent as StorageSVG } from "../../images/new_ui/storage.svg";
import { ReactComponent as ArrowSVG } from "../../images/new_ui/nextarrow.svg";
import { ReactComponent as ContentSVG } from "../../images/new_ui/addcontent.svg";
import { ReactComponent as AddSVG } from "../../images/new_ui/addArrow.svg";
import ReactApexChart from 'react-apexcharts';
import logo from "../../images/new_ui/lite-logo.png";
import { useNavigate } from "react-router-dom";
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import AddContent from "../../components/Add_Content/AddContent"


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: '#1A1A1A',
  border: '1px solid #262626',
  boxShadow: 24,
  borderRadius: "5px",
  p: 4,
  height: '74%'
};

const HomeCms = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const [openPopup, setOpenPopup] = useState(false);
  const [userRoleType, setUserRoleType] = useState("");
  const [userRoleID, setuserRoleID] = useState("");
  const [sessionTotal, setSessionTotal] = useState("")
  const [storageData, setStorageData] = useState({ used: 0, remaining: 100 });
  const [totalUploadedSizeMB, setTotalUploadedSizeMB] = useState(0);
  const handleOpen = () => setOpenPopup(true);
  const handleClose = () => setOpenPopup(false);
  const [fileDetails, setFileDetails] = useState(null);
  useEffect(() => {
    const roleType = sessionStorage.getItem('userRoleType');
    const userRoleID = sessionStorage.getItem('userRoleID');
    setUserRoleType(roleType);
    setuserRoleID(userRoleID);
    getUsersList();
    getFileDetails();
  }, []);

  const formatStorageSize = (sizeInMB) => {
    if (sizeInMB < 1) {
      const sizeInKB = sizeInMB * 1024;
      return `${sizeInKB.toFixed(2)} KB`;
    } else if (sizeInMB < 1024) {
      return `${sizeInMB.toFixed(2)} MB`;
    } else {
      const sizeInGB = sizeInMB / 1024;
      return `${sizeInGB.toFixed(2)} GB`;
    }
  };

  async function getFileDetails() {
    dispatch(sidebarReducer.apiLoad(true));
    try {
      const response = await axios.get(
        "/contentlogic/filedetails/" +
        JSON.parse(sessionStorage.getItem("userdata")).te_companyid,
        {
          headers: {
            'Authorization': 'Bearer' + ' ' + sessionStorage.getItem("access_token")
          }
        }
      );
      if (response.status === 200) {
        dispatch(sidebarReducer.apiLoad(false));
        setFileDetails(response.data.data);
        const totalMaxSizeMB = parseFloat(response.data.data.total_max_size_mb.replace(" MB", ""));
        const totalUploadedSizeMB = parseFloat(response.data.data.total_uploaded_size_mb.replace(" MB", ""));
        const usedPercentage = (totalUploadedSizeMB / totalMaxSizeMB) * 100;
        setTotalUploadedSizeMB(totalUploadedSizeMB);
        setStorageData({
          used: usedPercentage,
          remaining: 100 - usedPercentage
        });

      } else {
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      }
    } catch (err) {
      dispatch(sidebarReducer.stringUpdate("AppDown"));
    }
  }
  const closeContentPopup = () => {
    setOpenPopup(false);
  }
  let totalUsedGB = fileDetails ?
    parseFloat(fileDetails.image_size_gb) +
    parseFloat(fileDetails.video_size_gb) +
    parseFloat(fileDetails.audio_size_gb) +
    parseFloat(fileDetails.object3d_size_gb) +
    parseFloat(fileDetails.file_size_gb) : 0;

  let totalUsedPercentage = (totalUsedGB / 100) * 100; // Assuming 100GB total storage
  const values = {
    series: [storageData.used, storageData.remaining],
    options: {
      dataLabels: {
        enabled: false,
      },
      chart: {
        type: 'pie',
      },
      plotOptions: {
        pie: {
          size: 100
        }
      },
      labels: ["Used", "Remaining"],
      stroke: {
        colors: ['#FFD119', '#ffd11988']
      },
      theme: {
        monochrome: {
          enabled: true
        }
      },
      fill: {
        colors: ['#0F0F0F']
      },
      legend: {
        show: false
      },
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 50
          },
          legend: {
            show: false
          }
        }
      }]
    },
  };

  const shouldUseMB = (values) => {
    return values.every(val => val < 0.01);
  };

  // Function to convert GB to MB
  const gbToMb = (gb) => gb * 1024;

  // Prepare the data
  let dataInGB = fileDetails ? [
    parseFloat(fileDetails.audio_size_gb),
    parseFloat(fileDetails.file_size_gb),
    parseFloat(fileDetails.object3d_size_gb),
    parseFloat(fileDetails.video_size_gb),
    parseFloat(fileDetails.image_size_gb)
  ] : [0, 0, 0.5, 0, 0];

  let useMB = shouldUseMB(dataInGB);

  let dataToUse = useMB ? dataInGB.map(gbToMb) : dataInGB;

  let barvalues = {
    series: [{
      data: dataToUse
    }],
    options: {
      chart: {
        type: 'bar',
        height: 350,
        toolbar: {
          show: false,
        },
      },

      plotOptions: {
        bar: {
          borderRadius: 4,
          endingShape: 'rounded',
          borderRadiusApplication: 'end',
          borderRadiusWhenStacked: 'last',
          horizontal: true,
          columnWidth: '30%',
          barHeight: '20%',
        }
      },
      grid: {
        borderColor: '#262626',
        xaxis: {
          lines: {
            show: true
          }
        }
      },
      legend: {
        show: false
      },
      fill: {
        colors: ['#FFD119']
      },
      dataLabels: {
        enabled: false,
        formatter: function (val) {
          return val.toFixed(3) + (useMB ? " MB" : " GB");
        },
        style: {
          colors: ['#FFFFFF'],
          fontSize: '12px',
          fontWeight: 400
        },
        offsetX: 30
      },
      xaxis: {
        categories: ['Recordings', 'Meta Data', '3d Model', 'Videos', 'Images'],
        labels: {
          show: true,
          style: {
            colors: ['#999999'],
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 300,
          },
          formatter: function (value) {
            return value.toFixed(3) + (useMB ? " MB" : " GB");
          }
          // formatter: function (value) {
          //   return value.toFixed(2) + (useMB ? " MB" : " GB");
          // }
        },
        tickAmount: 5,
        min: 0,
        max: function (max) { return Math.ceil(max); }
      },
      yaxis: {
        labels: {
          show: true,
          align: 'right',
          style: {
            colors: ['#999999'],
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 300,
          },
        },
      },
      tooltip: {
        y: {
          title: {
            formatter: function () {
              return ''; // This removes the "Series 1" label
            }
          },
          formatter: function (val) {
            return val.toFixed(3) + (useMB ? " MB" : " GB");
          }
        }
      },

    },
  };

  async function getUsersList() {
    dispatch(sidebarReducer.apiLoad(true));
    // setApiLaod(true);
    await axios
      .get(
        "/unitysession/listUser/" +
        JSON.parse(sessionStorage.getItem("userdata")).te_userid,
        {
          headers: {
            'Authorization': 'Bearer' + ' ' + sessionStorage.getItem("access_token")
          }
        })

      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          // console.log("get all content", response.data.data.length);
          setSessionTotal(response.data.data.length)
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  }



  return (
    <div className="home-cms">
      <div className="container-fluid">
        <div className="search-section">
          <div></div>
          <div className="container">
            <div className="row">
              <SearchBarComponent className="search-bar-div" />
            </div>
          </div>

          <button className="add-button" type="button" onClick={handleOpen}>
            <div className="centered-div">
              <ContentSVG
                style={{
                  width: "40px",
                  height: "auto",
                  margin: "0px 10px",
                  cursor: "pointer",
                }}
              />
              <p>Add Content</p>
            </div>
            <div className="next-buttons">
              <AddSVG
                style={{
                  width: "15px",
                  height: "auto",
                  margin: "0px 5px",
                  cursor: "pointer",
                }}
              />
            </div>
          </button>
        </div>
        <div className="container">
          <div className="home-cards">
            <div className="left-column">
              <div className="card-section">
                <div>
                  <div className="title-section">
                    <StorageSVG
                      style={{
                        width: "40px",
                        height: "auto",
                        margin: "0px 10px",
                      }}
                    />
                    Storage
                  </div>
                  <div className="card-bottom-section">
                    <div className="card-one">
                      <div id="chart">
                        <ReactApexChart
                          options={values.options}
                          series={values.series}
                          type="pie"
                        />
                      </div>
                      {/* <div className="title">
                        {storageData.used.toFixed(2)}% Used
                      </div>
                      <div>{storageData.remaining.toFixed(2)}% Remaining</div> */}
                      <div className="title">
                        Used Storage
                      </div>
                      <div className="title">
                        {formatStorageSize(totalUploadedSizeMB)}
                      </div>
                      <div class="arrow-container" title="View Content">
                        <ArrowSVG
                          className="Arrow-image"
                          onClick={() => {
                            navigate("/content-list");
                          }}
                          style={{
                            width: "30px",
                            height: "auto",
                            margin: "0px 10px",
                            cursor: "pointer",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {userRoleType === "cms_user" && userRoleID !== "98" && (
                <>

                  <div className="card-section">
                    <div>
                      <div className="title-section">
                        <StorageSVG
                          style={{
                            width: "40px",
                            height: "auto",
                            margin: "0px 10px",
                          }}
                        />
                        Software Details
                      </div>
                      <div className="card-bottom-section">
                        <table>
                          <tr>
                            <td className="title">Lite Pack</td>
                            <td style={{ textAlign: "right" }}>
                              <img src={logo} alt="" />
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Size- 4GB <br /> Version- 1.0.1
                            </td>
                            <td>Release Date- 20-Apr-2024</td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div className="card-section">
                    <div>
                      <div className="title-section">
                        <Sessionlogo
                          style={{
                            width: "40px",
                            height: "auto",
                            margin: "0px 10px",
                          }}
                        />
                        Past sessions
                      </div>
                      <div className="card-bottom-section">
                        <div className="card-one">
                          <div className="title">Sessions</div>
                          <div>{sessionTotal} Session history</div>
                          <div>Last session recorded on.....</div>
                          <br></br>
                          <div class="arrow-container" title="View Past Sessions">
                            <ArrowSVG
                              className="arrow-button"
                              onClick={() => {
                                navigate("/past-session");
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {userRoleType !== "cms_user" && (
                <div className="card-section">
                  <div>
                    <div className="title-section">
                      <Sessionlogo
                        style={{
                          width: "40px",
                          height: "auto",
                          margin: "0px 10px",
                        }}
                      />
                      Past sessions
                    </div>
                    <div className="card-bottom-section">
                      <div className="card-one">
                        <div className="title" style={{ height: "80px" }}>
                          Sessions
                        </div>
                        <div>{sessionTotal} Session history</div>
                        <div>Last session recorded on.....</div>
                        <br></br>
                        <div class="arrow-container" title="View Past Sessions">
                          <ArrowSVG
                            className="arrow-button"
                            onClick={() => {
                              navigate("/past-session");
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="right-column">
              <div className="analytics-card">
                <div className="title-section">
                  <AnalyticsSVG
                    style={{
                      width: "40px",
                      height: "auto",
                      margin: "0px 10px",
                    }}
                  />
                  Analytics
                </div>
                <div id="chart">
                  <ReactApexChart
                    options={barvalues.options}
                    series={barvalues.series}
                    type="bar"
                    height={500}
                    width={600}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        open={openPopup}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <button className="close-popup" onClick={handleClose}>
            x
          </button>
          <AddContent closeContentPopup={closeContentPopup}></AddContent>
        </Box>
      </Modal>
    </div>
  );
};

export default HomeCms;
